import { atom } from "jotai";
import { selectAtom } from "jotai/utils";
import { PublishState } from "@src/types.generated";
import { isEqual } from "lodash";
import { TrainingResourceVersionFragment } from "@src/fragments.generated";

export const trainingResourceVersionAtom = atom<
  TrainingResourceVersionFragment | undefined
>(undefined);

export const trainingResourceVersionIdAtom = selectAtom(
  trainingResourceVersionAtom,
  (val) => val?.id,
  isEqual,
);

export const richTextDocumentIdAtom = selectAtom(
  trainingResourceVersionAtom,
  (val) => val?.richTextDocument?.id,
  isEqual,
);

export const selectedTrainingResourceIdAtom = selectAtom(
  trainingResourceVersionAtom,
  (val) => val?.trainingResource?.id,
  isEqual,
);

export const currentStateIsPublishedAtom = selectAtom(
  trainingResourceVersionAtom,
  (val) =>
    val?.trainingResource?.libraryItem?.publishState === PublishState.Published,
  isEqual,
);
export const trainingResourceIdAtom = selectAtom(
  trainingResourceVersionAtom,
  (val) => val?.trainingResource?.id,
  isEqual,
);

export const trainingResourceTitleAtom = selectAtom(
  trainingResourceVersionAtom,
  (val) => val?.trainingResource?.libraryItem?.name,
  isEqual,
);

/**
 * The resource whose PDF-to-document conversion this session started, so its
 * page can open the new document for review when it lands — only for the
 * person who asked, and only on that resource.
 */
export const pdfConversionRequestedAtom = atom<string | null>(null);
